import { ScheduleActivityHistoryItem } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/schedule_activity.pb';
import { i18next } from '@frontend/i18n';
import { getFullName } from '@frontend/name';
import type { UsersTypes } from '@frontend/user-helpers';
import { activityTypeLabels } from '../../schedule-activity/constants';

export const isAiActivity = (activitySourceType?: string) => {
  if (!activitySourceType) return false;
  return activitySourceType === 'AI_VOICE' || activitySourceType === 'AI_TEXT';
};

export const getActorLabel = (history: ScheduleActivityHistoryItem, locationUsers: UsersTypes.UserProfile[]) => {
  if (history.actor?.actorType === 'AI') {
    return i18next.t('AI Receptionist', { ns: 'schedule-activity' });
  }

  const userDetails = locationUsers.find((user) => user.UserID === history.actor?.actorUserId);

  return history.actor?.actorUserName
    ? i18next.t('By {{actorUserName}}', {
        ns: 'schedule-activity',
        actorUserName: history.actor.actorUserName || getFullName(userDetails ?? {}),
      })
    : '';
};

export const getActivityTitle = (history: ScheduleActivityHistoryItem) => {
  let actorLabel = '';
  const actionLabel =
    activityTypeLabels[history.activityType as keyof typeof activityTypeLabels] || history.activityType || '';

  switch (history.actor?.actorType) {
    case 'STAFF':
      actorLabel = i18next.t('by Staff', { ns: 'schedule-activity' });
      break;
    case 'AI':
      actorLabel = i18next.t('via AI Receptionist', { ns: 'schedule-activity' });
      break;
    case 'PMS':
      actorLabel = i18next.t('via PMS', { ns: 'schedule-activity' });
      break;
    case 'PATIENT':
      if (history.activitySourceType === 'BOOKING_SITE') {
        actorLabel = i18next.t('via Online Scheduling', { ns: 'schedule-activity' });
      }
      if (history.activitySourceType === 'WAITLIST') {
        actorLabel = i18next.t('via Waitlist', { ns: 'schedule-activity' });
      }
      break;
    default:
      actorLabel = '';
  }

  return `${actionLabel}  ${actorLabel}`;
};
